/* eslint import/prefer-default-export: off */

import React from 'react'

export const DictionaryContext = React.createContext({})